import { useEffect, useState, useContext } from "react";
import { Button } from "@mui/material";
import InputText from "../../../shared/components/inputs/InputText/InputText";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../categoriasFinanceiro/CategoriasFinanceiro.scss";
import { AuthContext } from "../../../shared/context/auth-context";
import { Popconfirm } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import toast from "react-hot-toast";
import { useLoading } from "../../../shared/context/LoadingContext";

import "./Instituicoes.scss";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotaPartilhaUnidades from "../components/NotaPartilhaUnidades";

function Instituicoes({ sendRequest, clinicaId }) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nomeInstituicao, setNomeInstituicao] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [idInstituicao, setIdInstituicao] = useState(null);
  const [instituicoes, setInstituicoes] = useState([]);
  const [mensagemDeErro, setMensagemDeErro] = useState("");
  const auth = useContext(AuthContext);

  const [modalidadesPagamento, setModalidadesPagamento] = useState({
    DIRETO: false,
    REEMBOLSO_CLIENTE: false,
  });

  useEffect(() => {
    const fetchInstituicoes = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/clinica/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setInstituicoes(responseData.instituicoes);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchInstituicoes();
  }, [auth.token, clinicaId, sendRequest]);

  const nomeInstituicaoChangeHandler = (valor) => {
    setNomeInstituicao(valor);
  };

  const guardarInstituicao = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeInstituicao);
      formData.append("tipo", "SEGURO");
      formData.append("clinica", clinicaId);
      formData.append("criadoPor", auth.userId);

      const modalidadesPagamentoFormatada = [
        {
          nome: "Pagamento Direto",
          codigo: "DIRETO",
          ativo: modalidadesPagamento.DIRETO,
        },
        {
          nome: "Reembolso Cliente",
          codigo: "REEMBOLSO_CLIENTE",
          ativo: modalidadesPagamento.REEMBOLSO_CLIENTE,
        },
      ];

      formData.append(
        "modalidadesPagamento",
        JSON.stringify(modalidadesPagamentoFormatada)
      );

      const instituicaoCriada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      setInstituicoes((current) => [...current, instituicaoCriada.instituicao]);
      resetarValores();

      setOpenModal(false);
      setIdInstituicao(null);

      toast.success("Instituição criada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const editarInstituicao = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nomeInstituicao);
      formData.append("atualizadoPor", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      const instituicaorCopy = [...instituicoes];
      const instituicoesModificadas = instituicaorCopy.map((clf) => {
        if (clf.id === id) {
          return {
            id: id,
            _id: id,
            nome: nomeInstituicao,
          };
        } else {
          return clf;
        }
      });

      setInstituicoes([...instituicoesModificadas]);

      resetarValores();
      setIdInstituicao(null);
      setOpenModal(false);

      toast.success("Instituição modificada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const preEditarInstituicao = async (id) => {
    setIdInstituicao(id);
    const instituicaoFiltrado = instituicoes.filter((cat) => cat.id === id)[0];

    setNomeInstituicao(instituicaoFiltrado.nome);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setMensagemDeErro("");
    setIdInstituicao(null);
    setOpenModal(false);
    resetarValores();
  };

  const resetarValores = () => {
    setNomeInstituicao("");
    setModalidadesPagamento({
      DIRETO: false,
      REEMBOLSO_CLIENTE: false,
    });
  };

  const desativarInstituicao = async (id) => {
    startLoading();
    try {
      const formDataDesativar = new FormData();
      formDataDesativar.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/instituicoes/toggleativo/${id}`,
        "PATCH",
        formDataDesativar,
        {
          Authorization: "Bearer " + auth.token,
        }
      );
      setInstituicoes((current) => current.filter((cat) => cat.id !== id));

      toast.success("Instituicao desativado com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const beforeSubmit = (idInstituicao) => {
    let haErro = false;

    let duplicidadeInstituicao = false;
    if (idInstituicao) {
      duplicidadeInstituicao = instituicoes.filter(
        (c) =>
          c._id !== idInstituicao &&
          c.nome.toLowerCase() === nomeInstituicao.trim().toLowerCase()
      );
    }

    if (!nomeInstituicao || nomeInstituicao.trim() === "") {
      setMensagemDeErro("Preencha todos os campos assinalados com *");
      haErro = true;
    } else if (idInstituicao && duplicidadeInstituicao?.length > 0) {
      setMensagemDeErro("Já existe um Instituicao com esse nome.");
      haErro = true;
    } else {
      setMensagemDeErro("");
    }

    if (!isSubmitting && !haErro) {
      setIsSubmitting(true);
      if (idInstituicao) {
        editarInstituicao(idInstituicao);
      } else {
        guardarInstituicao();
      }
    }
  };

  const handleChangeModalidadePagamento = (event) => {
    const { name, checked } = event.target;
    setModalidadesPagamento((prevState) => ({
      ...prevState,
      [name]: checked, // Atualiza o valor do checkbox correspondente
    }));
  };

  return (
    <>
      <div className="categoriasGeral__container">
        {(auth.role === "Médico/Administrador" || auth.role === "Gerente") && (
          <div
            className="categoriasGeral__container__btn-adicionar"
            style={{ width: "240px" }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={(e) => setOpenModal(true)}
            >
              Nova Instituição
            </Button>
          </div>
        )}

        <div
          style={{
            backgroundColor: "#e8f5e9",
            border: "1px solid #a5d6a7",
            borderRadius: "8px",
            padding: "16px 20px",
            marginBottom: "20px",
            display: "flex",
            gap: "15px",
            alignItems: "flex-start",
            gridColumn: "1/-1",
          }}
        >
          <InfoOutlinedIcon style={{ color: "#2e7d32", marginTop: "2px" }} />
          <div
            style={{ fontSize: "14px", color: "#1b5e20", lineHeight: "1.6" }}
          >
            <strong
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "15px",
              }}
            >
              O que são Instituições?
            </strong>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                Instituições são entidades que oferecem{" "}
                <strong>cobertura de tratamentos</strong> (ex: INPS, BCA).
              </li>
              <li>
                Ao criar orçamentos, pode associar uma instituição para indicar
                comparticipação.
              </li>
              <li>
                Configure as <strong>modalidades de pagamento</strong>{" "}
                disponíveis: Pagamento Direto ou Reembolso ao Cliente, se a
                instituição os permitir.
              </li>
              <NotaPartilhaUnidades />
            </ul>
          </div>
        </div>

        {instituicoes &&
          instituicoes.map((instituicao, index) => (
            <div
              className="categoriasFinanceiro__container__categoria"
              key={index}
            >
              <div className="categoriasFinanceiro__container__categoria--1">
                {instituicao.nome}
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                {(auth.role === "Médico/Administrador" ||
                  auth.role === "Gerente") &&
                  instituicao.nome.toUpperCase() !== "INPS" && (
                    <Popconfirm
                      title={`Desativar Instituicao`}
                      description={`Confirma desativação do Instituicao?`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={desativarInstituicao.bind(
                        null,
                        instituicao.id
                      )}
                      className="popConfirm--biggerPadding"
                    >
                      <span>Desativar</span>
                    </Popconfirm>
                  )}
                {(auth.role === "Médico/Administrador" ||
                  auth.role === "Gerente") &&
                  instituicao.nome.toUpperCase() !== "INPS" && (
                    <span
                      onClick={preEditarInstituicao.bind(null, instituicao.id)}
                    >
                      Editar
                    </span>
                  )}
              </div>
            </div>
          ))}

        <Modal
          open={openModal}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="fluxo-atendimento__modal__box adicionar-categoria__modal"
            id="modal__adicionar-categoria"
          >
            <h1 className="fluxo-atendimento__modal__titulo">Instituição</h1>
            <div
              className="adicionar-categoria__modal__container"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Nome do Instituição *"
                initialValue={nomeInstituicao}
                handleChange={nomeInstituicaoChangeHandler}
                id="1"
              />

              <div className="modalidadesPagamento__container">
                <span className="modalidadesPagamento__container__title">
                  Modalidades de pagamento
                </span>
                <div className="modalidadesPagamento__container__checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      name="DIRETO"
                      checked={modalidadesPagamento.DIRETO}
                      onChange={handleChangeModalidadePagamento}
                    />
                    Pagamento Direto
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      name="REEMBOLSO_CLIENTE"
                      checked={modalidadesPagamento.REEMBOLSO_CLIENTE}
                      onChange={handleChangeModalidadePagamento}
                    />
                    Reembolso Cliente
                  </label>
                </div>
              </div>

              {mensagemDeErro && (
                <div className="erroContainer__categoria-caixa">
                  {mensagemDeErro}
                </div>
              )}

              <div className="fluxo-atendimento__modal__bottom_btns">
                <span
                  className="cancel-btn"
                  onClick={handleModalClose}
                  style={{ display: "block" }}
                >
                  Fechar
                </span>

                <span
                  disabled={isSubmitting}
                  className="blue-button"
                  onClick={
                    idInstituicao
                      ? beforeSubmit.bind(null, idInstituicao)
                      : beforeSubmit.bind(null, null)
                  }
                >
                  {idInstituicao
                    ? isSubmitting
                      ? "Guardando"
                      : "Guardar"
                    : isSubmitting
                    ? "Guardando"
                    : "Guardar"}
                </span>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Instituicoes;
